// extracted by mini-css-extract-plugin
export default {"offerDetail":"OfferDetail_offerDetail__UNXSQ","icon":"OfferDetail_icon__y50Qa","content":"OfferDetail_content__kcio6","backButton":"OfferDetail_backButton__tfk-p"};